import React from 'react'

export const findOneByName = (children: React.ReactNode, name: string) => {
  return React.Children.toArray(children).find(child => {
    if (!React.isValidElement(child)) return false
    if (child.type && typeof child.type === 'function' && 'displayName' in child.type) {
      return child.type.displayName === name
    }
    if (child.type && typeof child.type === 'object' && 'displayName' in child.type) {
      // @ts-expect-error type error
      return child.type.displayName === name
    }
    return false
  })
}
